<template>
  <div class="selected">
    <div class="row mb-5">
      <div class="col">
        <h2>{{ $t("additionals") }}</h2>
      </div>
      <div class="col-auto ml-auto ms-auto">
        <button class="btn btn-primary" @click="progress.additionals.overview = false;progress.additionals.show = true;scrollToElement(progress.additionals.name);">
          {{ $t("edit") }}
        </button>
      </div>
    </div>
    <div class="row" v-if="reservation.additionals.length > 0">
      <!-- <div class="col-12">
        <div class="row mb-3">
          <div class="col-6 col-md-5">
            <h4 class="label">Artikel</h4>
          </div>
          <div class="col-2 col-md-3">
            <h4 class="label">Price</h4>
          </div>
          <div class="col-2">
            <h4 class="label">Anzahl</h4>
          </div>
          <div class="col-2 text-right text-end">
            <h4 class="label">Summe</h4>
          </div>
        </div>
      </div> -->
      <div class="col-12 ">
        <div class="additionals-summary" v-for="(additional, index) in reservation.additionals" :key="'additional' + index">
          <div class="row">
            <div class="col-6 col-md-5">
              <h4>{{ additional.title }}</h4>
            </div>
            <div class="col-2 col-md-3">
              <h4>{{ additional.price }} &euro;</h4>
            </div>
            <div class="col-2">
              <h4>{{ additional.amount }}</h4>
            </div>
            <div class="col-2 text-right text-end">
              <h4>{{ additional.amount * additional.price }} &euro;</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col">
        {{ $t("no-additionals") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdditionalsSummary",
  inject: ["reservation", "progress"],
  data() {
    return {
      //progress: progress,
      //reservation: Reservation,
    };
  },

  computed: {
    totalAdditionals() {
      var additionalSum = 0.0;
      this.reservation.additionals.forEach((obj) => {
        additionalSum += obj.amount * obj.price;
      });
      return additionalSum;
    },
  },
};
</script>